// 待办事项-预约中心操作详情
<template>
  <div class="AppletFillInVisitorInfo" v-if="detail.user_id">
    <!-- 待办事项-预约中心操作详情 -->
      <div class="tit">来访信息</div>
      <div class="list">
        <div class="li">
          <div class="left">邀请时间</div>
          <div class="right">{{detail.create_time}}</div>
        </div>
        <div class="li">
          <div class="left">邀请人</div>
          <div class="right">{{detail.vname}}</div>
        </div>
        <div class="li">
          <div class="left">电话</div>
          <div class="right">{{detail.vphone}}</div>
        </div>
        <div class="li">
          <div class="left">来访时间</div>
          <div class="right">{{detail.appoint_time}}</div>
        </div>
      </div>
      <div class="tit">访客信息</div>
      <div class="list">
        <div class="li">
          <div class="left">访客姓名</div>
          <div class="right">{{detail.invite_name}}</div>
        </div>
        <div class="li">
          <div class="left">访客电话</div>
          <div class="right">{{detail.invite_phone}}</div>
        </div>
        <template v-if="detail.is_show_cpl == 1">
          <div class="li">
            <div class="left">是否预约车位</div>
            <div class="right">
              <van-switch v-model="isCarChecked" size="0.36rem" active-color="#07c160" inactive-color="#cccccc" />
            </div>
          </div>
          <div class="li" v-if="isCarChecked">
            <div class="left">车牌号</div>
            <div class="right">
              <div class="region" @click="regionShow = true">{{detail.licence[regionIndex]}}</div>
              <input type="text" class="pNumber" name="plate_number" v-model="plate_number" placeholder="请输入车牌号" />
            </div>
          </div>
        </template>
        <div class="li vphoto">
          <div class="left">访客照片</div>
          <div class="right" v-if="vphoto === ''">
            <van-uploader :after-read="afterRead">
              <div class="des">
                <span class="text">请提交访客本人照片</span>
                <span class="ico ico-camera"></span>
              </div>
            </van-uploader>
          </div>
          <div class="right" v-else>
            <van-uploader :after-read="afterRead">
              <img class="img" :src="vphoto" alt="">
            </van-uploader>
          </div>
        </div>
      </div>

      <div class="btnArea">
        <div class="btn" @click="reset">重置访客信息</div>
        <div class="btn" @click="updateDeviceAppointStatus">提交并同意来访</div>
      </div>

    <!-- 车位地区选择 -->
    <!-- <div class="region-wrapper" v-show="regionShow"> -->
    <van-popup class="region-wrapper" v-model="regionShow" position="bottom" :close-on-click-overlay=false>
      <div class="region-box">
        <div :class="['text', {'selected' : regionIndex === index}]" v-for="(item, index) in detail.licence" :key="item"  @click="selectRegion(index)">{{item}}</div>
      </div>
      <div class="btn-cancel" @click="regionShow = false">取消</div>
    </van-popup>

    <!-- 确认待上传的访客照片 -->
    <van-popup class="imgDio" v-model="imgDioShow" :close-on-click-overlay=false>
        <div class="imgDio_content">
          <!-- <img id="initImg" class="hide" style="" src="/static/images/dkb/Access/2.jpg" alt="" @load="drawInitImg($event)"> -->
          <img id="initImg" class="hide" style="" :src="initImgSrc" alt="" @load="drawInitImg($event)">
          <div class="canvasImgBox">
            <img id="canvasImgUrl" :src="canvasImgUrl" class="canvasImgUrl" alt="">
          </div>
          <img class="icon" src="/static/images/icon/icon_rorate.png" alt="" @click="rotateImg">
          <!-- <p class="ico ico-xuanzhuan" @click="rotateImg"></p> -->
          <div class="btnArea">
            <p class="text" @click="imgDioShow=false">取消</p>
            <p class="text h" @click="drawInitImg('init')">还原</p>
            <p class="text" @click="confirmImg">完成</p>
          </div>
        </div>
      </van-popup>

  </div>
</template>

<script>
  import { AppletApi, RKEApi } from '../../../../static/js/phone/phoneApi.js'
  import { vshowLoading, vhideLoading, vshowSuccess, vshowToast, vconfirm, vshowWarning  } from '../../../../static/js/phone/utility.js'
  import * as wx from "../../../../static/js/phone/jweixin-1.3.2.js"
  import lrz from 'lrz' 

  import Vue from 'vue'
  import { Switch, Popup } from 'vant'
  Vue.use(Switch)
  Vue.use(Popup)

  let vm, n= 0

  export default {
    name: 'AppletFillInVisitorInfo',
    components: {
    },
    data () {
      return {
        isMiniprogram: false,

        id: '',
        user_id: '',
        vphoto: '',
        plate_number: '',

        
        imgDioShow: false,
        initImgSrc: '',
        canvasImgUrl: '',

        type: '',
        detail: {
          user_id: ''
        },

        isCarChecked: false,  // 是否预约车位
        regionShow: false, // 显示/隐藏车位地区选择
        regionIndex: 0, // 地区

        confirmImgShow: false, // 确认图片显隐
      }
    },
    created () {
      vm = this
      vm.judgeIsMini()
    },
    mounted () {
      vm.id = vm.$route.params.id
      vm.user_id = vm.$route.params.user_id
      vm.getAppointInfo()
    },
    methods: {
      // 判断所处环境是否在小程序中
      judgeIsMini () {
        wx.miniProgram.getEnv(function(res) {
          vm.isMiniprogram  = res.miniprogram
        })
      },
      // 获取待办事项列表详情
      getAppointInfo () {
        let data = {
          id: vm.id,
          user_id: vm.user_id
        }

        vshowLoading('加载中')
        AppletApi.getAppointInfo(data).then(function(res){
          vhideLoading()
          if (res.meta.code == 200) {
            vm.detail = res.data
          } else {
            vshowWarning(res.meta.message)
          }
        })
      },
      // 选择地区
      selectRegion (index) {
        vm.regionIndex = index
        vm.regionShow = false
      },

      
      // 点击添加/修改照片
      afterRead(file) {
        // 此时可以自行将文件上传至服务器
        console.log('图片初始信息',file)

        lrz(file.file, {width: 800})
          .then(function (rst) {
              // 处理成功会执行
              console.log('处理成功rst', rst);
              // console.log('处理成功rst.file', rst.file)
              vm.initImgSrc = rst.base64
              vm.imgDioShow = true
          })
          .catch(function (err) {
              // 处理失败会执行
              vNotify('图片上传失败，请重新选择')
          })
          .always(function () {
              // 不管是成功失败，都会执行
          });
      },
      //初始加载待上传图片/还原照片
      drawInitImg (e) {
        // console.log('e', e)
        vshowLoading('处理中...')
        let canvas = document.createElement('canvas')
        var ctx = canvas.getContext("2d")
        let imgObj = e === 'init' ? document.getElementById("initImg") : e.target
        let image = null
        // console.log('imgObj', imgObj)
        canvas.width = imgObj.width
        canvas.height = imgObj.height
        ctx.drawImage(imgObj, 0, 0, imgObj.width, imgObj.height)
        
        // console.log('imgObj宽高', imgObj.width, imgObj.height)
        console.log('canvas宽高', canvas.width, canvas.height)

        image = canvas.toDataURL('image/jpg')
        vm.canvasImgUrl = image
        vhideLoading()
      },
      // canvas旋转图片
      rotateImg () {
        n = n+1
        // console.log('n', n)
        vshowLoading('处理中...')
        var canvas = document.createElement('canvas')
        var ctx = canvas.getContext("2d")
        var imgObj = document.getElementById("initImg")
        console.log('imgObj宽高', imgObj.width + '*' + imgObj.height)

        switch (n) {
            case 1:
                canvas.width = imgObj.height
                canvas.height = imgObj.width
                ctx.rotate(270 * Math.PI / 180)
                ctx.drawImage(imgObj, -imgObj.width, 0, imgObj.width, imgObj.height)
                break;
            case 2:
                canvas.width = imgObj.width
                canvas.height = imgObj.height
                ctx.rotate(180 * Math.PI / 180)
                ctx.drawImage(imgObj, -imgObj.width, -imgObj.height, imgObj.width, imgObj.height)
                break;
            case 3:
                canvas.width = imgObj.height
                canvas.height = imgObj.width
                ctx.rotate(90 * Math.PI / 180)
                ctx.drawImage(imgObj, 0, -imgObj.height, imgObj.width, imgObj.height);
                break;
            default:
                n = 0
                canvas.width = imgObj.width
                canvas.height = imgObj.height
                ctx.drawImage(imgObj, 0, 0, imgObj.width, imgObj.height)
                break;
        }
        var image = canvas.toDataURL('image/jpg')
        vm.canvasImgUrl = image
        vhideLoading()
      },
      // 上传接口时：需将base64URL转换为file
      dataURLtoFile(dataurl, filename) {
        // console.log('dataurl', dataurl)
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n)
        while(n--){
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], filename, {type: mime});
      },
      // 确认图片-并上传
      confirmImg () {
        let formData = new FormData()
        let raw = vm.dataURLtoFile(vm.canvasImgUrl, 'face.jpg')
        formData.append('file', raw)
        vm.imgDioShow = false
        vm.uploadImage({formData: formData})
      },
      // 上传图片
      async uploadImage (data) {
        let res = await RKEApi.uploadImage(data.formData)
        // console.log('res', res)
        vshowLoading('上传图片中...')
        if (res.meta.code === 200) {
          vshowSuccess('上传图片成功')
          vm.vphoto = res.data
        } else {
          vNotify('图片上传失败，请重新上传')
        }
      },

      
      // 重置
      reset () {
        vconfirm('重置将会清除已填写信息，确认重置？').then(function () {
          vm.isCarChecked = true
          vm.regionIndex = 0
          vm.plate_number = ''
          vm.vphoto = ''
        }).catch(function () {
          // console.log('已取消', '')
        })
      },
      // 拒绝/同意来访（预约中心-修改设备预约得状态）
      updateDeviceAppointStatus () {
        console.log('plate_number', vm.plate_number)
        let vstatus = 1
        if (vm.detail.is_show_cpl == 1 && vm.isCarChecked) {
          if (vm.plate_number === '') {
            vshowToast('请输入车牌号')
            return
          }
        }
        if (vm.vphoto === '') {
          vshowToast('请提交访客本人照片')
          return
        }
        let data = {
          id: vm.id,
          user_id: vm.user_id,
          vstatus,
          vphoto: vm.vphoto,
        }
        if (vm.detail.is_show_cpl == 1 && vm.isCarChecked) {
          data.plate_number = vm.detail.licence[vm.regionIndex] + vm.plate_number
        }
        console.log('data:', data)

        let msg = '是否提交该申请？'
        vconfirm(msg).then(function () {
          vshowLoading('正在提交...')
          AppletApi.updateDeviceAppointStatus(data).then(function (res) {
            vhideLoading()
            if (res.meta.code == 200) {
              vshowSuccess('提交成功')
              vm.successOperation()
            } else {
              vshowWarning(res.meta.message)
            }
          })
        }).catch(function () {
          // console.log('取消', '')
        })
      },
      // 提交成功分场景操作（小程序端和网页端）
      successOperation () {
        console.log('vm.isMiniprogram', vm.isMiniprogram)
        if (vm.isMiniprogram) {
          setTimeout(() => {
            wx.miniProgram.navigateBack({ delta: 1 })
          }, 1000)
        } else {
          
        }
      }

    }
  }
</script>

<style lang="scss">
  .AppletFillInVisitorInfo {
    background-color: #f1f1f1;
    width: 100%;
    height: 100vh;
    // 上传图片
    .imgDio {
      width: 100%;
      height: 100vh;
      .imgDio_content {
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 1);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .icon {
          width: 0.35rem;
          height: 0.38rem;
          position: absolute;
          left: 0.5rem;
          bottom: 2rem;
        }
        .btnArea {
          width: 100%;
          height: 1.2rem;
          line-height: 1.2rem;
          font-size: 0.24rem;
          color: #ffffff;
          box-sizing: border-box;
          border-top: 1px solid #0e0e0e;
          display: flex;
          justify-content: space-between;
          position: absolute;
          left: 0;
          bottom: 0;
          .text {
            padding:  0 0.3rem;
            &.h {
              color: #474747;
            }
          }
        }
      }
      .canvasImgBox {
        width: 80%;
        margin: 0 auto 2.38rem;
        .canvasImgUrl {
          width: 100%;
        }
      }
    }
    /* 待办事项-预约中心操作详情 */
    .tit {
      padding-left: 0.3rem;
      font-size: 0.28rem;
      line-height: 0.8rem;
      color: #333333;
    }


    .list {
      width: 100%;
      padding-left: 0.3rem;
      background-color: #ffffff;
    }

    .list .li {
      width: 100%;
      height: 0.8rem;
      padding-right: 0.3rem;
      font-size: 0.3rem;
      color: #333333;
      border-bottom: 0.02rem solid #E7E7E7;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .list .li:last-child {
      border-bottom: none;
    }

    .list .li.vphoto {
      height: 1.2rem;
    }

    .list .li .right {
      color: #999999;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .list .li .region {
      padding: 0 0.1rem;
      border-radius: 0.04rem;
      border: 1px solid #999999;
    }

    .list .li .right .pNumber,
    .list .li .right .ico {
      margin-left: 0.2rem;
    }

    .list .li .right .ico {
      font-size: 0.6rem;
      color: #2D83F4;
    }

    .list .li .right .des {
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .list .li .right .img {
      height: 1rem;
    }

    .btnArea {
      width: 100%;
      padding-left: 0.3rem;
      display: flex;
      position: fixed;
      bottom: 0.2rem;
      left: 0;
    }

    .btn {
      width: 3.35rem;
      height: 0.88rem;
      line-height: 0.88rem;
      color: #ffffff;
      background-color: #1189F1;
      font-size: 0.26rem;
      border-radius: 0.08rem;
      text-align: center;
      box-sizing: border-box;
    }

    .btn+.btn {
      margin-left: 0.2rem;
    }

    /* 车牌地区选择器 */
    .region-wrapper {
      width: 100%;
      text-align: center;
    }

    .region-wrapper .region-box {
      width: 100%;
      padding: 0.3rem 0.25rem;
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
    }


    .region-wrapper .region-box .text {
      width: 0.7rem;
      height: 0.6rem;
      margin-right: 0.2rem;
      margin-bottom: 0.2rem;
      line-height: 0.6rem;
      font-size: 26rpx;
      color: #777777;
      background-color: #eaf3ee;
      border-radius: 0.04rem;
    }

    .region-wrapper .region-box .text:nth-child(8n) {
      margin-right: 0;
    }

    .region-wrapper .region-box .text.selected {
      color: #ffffff;
      background-color: #2D83F4;
    }

    .region-wrapper .btn-cancel {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      font-size: 0.28rem;
      color: #333333;
      background-color: #ffffff;
    }

    /* 确认待上传照片 */

    .imgDio_content {
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 1);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 9;
    }

    .imgDio_content .icon {
      width: 0.35rem;
      height: 0.38rem;
      position: absolute;
      left: 0.5rem;
      bottom: 2rem;
    }

    .imgDio_content .btnArea {
      width: 100%;
      height: 1.2rem;
      line-height: 1.2rem;
      font-size: 20.04rem;
      color: #ffffff;
      box-sizing: border-box;
      border-top: 1px solid #0e0e0e;
      display: flex;
      justify-content: space-between;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    .imgDio_content .btnArea .text {
      padding: 0 0.3rem;
    }

    .imgDio_content .btnArea .text.h {
      color: #474747;
    }

    .canvasImgBox {
      width: 80%;
      margin: 0 auto 2.38rem;
    }


    .canvasImgBox .canvasImgUrl {
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/PhonePage/Applet/FillInVisitorInfo.vue